<div class="st-drawer-wrapper send-budget-drawer flex flex-column">
  <!-- Header -->
  <div class="st-drawer-header show-border flex flex-column" style="align-items: flex-start; gap: 12px;">
    <div class="flex-center-between w-100">
      <span class="text-header-18 text-semibold">{{ nzData.budget ? 'Enviar presupuesto' : 'Enviar mensaje' }}</span>
      <app-st-icon class="text-header-16 cursor-pointer" (click)="close()" [name]="'close'" [bold]="true">
      </app-st-icon>
    </div>
    <!-- Badges de información -->
    <div class="info-badges flex gap-100" *ngIf="nzData.budget">
      <span class="st-badget subtle-grey">
        <label>Presupuesto: {{ nzData.budget.name || '-' }}</label>
      </span>
      <app-avatar-badge [entity]="nzData.budget.partner" [label]="'Cliente:'"
        *ngIf="nzData.budget?.partner"></app-avatar-badge>
    </div>
  </div>

  <!-- Content -->
  <div class="st-drawer-content">
    <form [formGroup]="emailForm" nz-form class="st-form" *ngIf="!loading">
      <!-- Para -->
      <nz-form-item class="minimal-form-item recipient-item">
        <nz-form-label [nzSpan]="2" nzRequired nzLabelAlign="left">Para</nz-form-label>
        <nz-form-control [nzSpan]="22" [nzErrorTip]="toErrorTpl">
          <nz-select formControlName="to" nzMode="multiple" [nzPlaceHolder]="''" nzBorderless class="recipient-select"
            [nzDropdownMatchSelectWidth]="false" [nzDropdownStyle]="{width: '300px'}">
            <nz-option *ngFor="let recipient of availableRecipients" [nzLabel]="getRecipientLabel(recipient)"
              [nzValue]="recipient.id" nzCustomContent>
              <div class="flex" style="align-items: center; justify-content: flex-start;">
                <app-avatar-badge [entity]="recipient" [labelProperties]="['name', 'surName']"></app-avatar-badge>
              </div>
            </nz-option>
          </nz-select>
          <ng-template #toErrorTpl let-control>
            <div class="flex gap-050 text-label-12" style="align-items: center; color: inherit;">
              <app-st-icon name="error" [bold]="true" style="font-size: 16px;"></app-st-icon>
              <span>Seleccione al menos un destinatario</span>
            </div>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <!-- CC -->
      <nz-form-item class="minimal-form-item recipient-item">
        <nz-form-label [nzSpan]="2" nzLabelAlign="left">CC</nz-form-label>
        <nz-form-control [nzSpan]="22">
          <nz-select formControlName="cc" nzMode="multiple" [nzPlaceHolder]="'Con copia...'" nzBorderless
            class="recipient-select" [nzDropdownMatchSelectWidth]="false" [nzDropdownStyle]="{width: '300px'}">
            <nz-option *ngFor="let recipient of availableRecipients" [nzLabel]="getRecipientLabel(recipient)"
              [nzValue]="recipient.id" nzCustomContent>
              <div class="flex" style="align-items: center; justify-content: flex-start;">
                <app-avatar-badge [entity]="recipient" [labelProperties]="['name', 'surName']"></app-avatar-badge>
              </div>
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <!-- Asunto -->
      <nz-form-item class="minimal-form-item" style="border-bottom: none;">
        <nz-form-label [nzSpan]="2" nzRequired nzLabelAlign="left">Asunto</nz-form-label>
        <nz-form-control [nzSpan]="22" [nzErrorTip]="subjectErrorTpl">
          <input nz-input formControlName="subject" placeholder="">
          <ng-template #subjectErrorTpl let-control>
            <div class="flex gap-050 text-label-12" style="align-items: center; color: inherit;">
              <app-st-icon name="error" [bold]="true" style="font-size: 16px;"></app-st-icon>
              <span>El asunto es requerido</span>
            </div>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <!-- Cuerpo del correo -->
      <nz-form-item class="body-form-item">
        <nz-form-control [nzSpan]="24" [nzErrorTip]="bodyErrorTpl">
          <quill-editor formControlName="body" [modules]="quillConfig" placeholder="Escriba el mensaje aquí...">
          </quill-editor>
          <ng-template #bodyErrorTpl let-control>
            <div class="flex gap-050 text-label-12" style="align-items: center; color: inherit;">
              <app-st-icon name="error" [bold]="true" style="font-size: 16px;"></app-st-icon>
              <span>El cuerpo del correo es requerido</span>
            </div>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <!-- Attachments Section (Footer-like) -->
      <div class="attachments-footer" style="border-top: none;">
        <app-st-icon name="attach_file" color="#666666"></app-st-icon>
        <span class="attachments-label">Adjuntos:</span>

        <!-- Lista de archivos (Inline) -->
        <div class="attachment-list-inline">
          <div *ngFor="let file of fileList" class="attachment-card-inline">
            <app-st-icon [avatar]="true" [bold]="true" name="description" color="#666666"></app-st-icon>
            <span class="file-name">{{ file.name }}</span>
            <app-st-icon class="cursor-pointer remove-icon" name="close" [bold]="true"
              (click)="removeFile(file)"></app-st-icon>
          </div>
        </div>

        <!-- Round Trigger Button -->
        <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload" [nzShowUploadList]="false"
          [nzMultiple]="true" class="upload-inline">
          <button nz-button nzType="default" nzShape="circle" class="flex-center">
            <app-st-icon name="add" [bold]="true"></app-st-icon>
          </button>
        </nz-upload>
      </div>
    </form>

    <!-- Loading -->
    <div *ngIf="loading" class="loading-container flex-center">
      <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
    </div>
  </div>

  <!-- Footer -->
  <div class="st-drawer-footer show-border">
    <button nz-button class="text-btn-14" nzType="text" nzShape="round" nzSize="large" (click)="close()"
      [nzLoading]="loading">
      <span>Cancelar</span>
    </button>
    <div class="flex-center gap-100">
      <!--      <button nz-button nzType="default" nzShape="round" nzSize="large" (click)="saveAsTemplate()"-->
      <!--        [nzLoading]="loading">-->
      <!--        <span>Guardar como nueva plantilla</span>-->
      <!--      </button>-->
      <button nz-button nzType="primary" nzShape="round" nzSize="large" (click)="sendEmail()" [nzLoading]="loading"
        [disabled]="emailForm.invalid">
        <span>Enviar</span>
      </button>
    </div>
  </div>
</div>

<!--  Notification  -->
<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
    [showUndo]="toastConfig.showUndo" [notRef]="notRef" [content]="toastConfig.content"
    [msg]="toastConfig.msg"></app-toast>
</ng-template>
